import { Dispatch } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { LocationState } from "history";

import { IStore } from "../../../store/rootReducer";

export interface IUseUtilsOutput {
  store: IStore;
  navigation: LocationState;
  dispatch: Dispatch<any>;
}

export function useUtils(): IUseUtilsOutput {
  const store = useSelector((s: IStore) => s);
  const navigation = useHistory();
  const dispatch = useDispatch();

  return {
    store,
    navigation,
    dispatch,
  };
}
